import styled from "styled-components";

export const ClientSettingsDropdownTogglerIconDefaultBox = styled.span<{ isOpen: boolean }>`
    cursor: pointer;
    transform: ${({ isOpen }) => isOpen ? 'rotate(90deg)' : 'rotate(-90deg)'};
    transition: transform 0.4s, color 0.4s;

    svg {
        width: 10px;
        height: 10px;
    }
`